import Address from "../../entities/address";

/**
 * Address actions
 *
 * Call order:
 *
 * ADDRESS_SAVE_QUEUE:	adds the item to the save queue
 * --> ADDRESS_SAVE:	modifies the state
 * --> ADDRESS_SAVE_SUCCESS: if all went well
 * --> ADDRESS_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ADDRESS_SAVE_QUEUE is during the call to ADDRESS_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ADDRESS_FETCH_ONE_QUEUE: any = 'ADDRESS_FETCH_ONE_QUEUE';
export const ADDRESS_FETCH_SUCCESS: any = 'ADDRESS_FETCH_SUCCESS';
export const ADDRESS_FETCH_FAILURE: any = 'ADDRESS_FETCH_FAILURE';
export const ADDRESS_FETCH_ONE_SUCCESS: any = 'ADDRESS_FETCH_ONE_SUCCESS';
export const ADDRESS_FETCH_ONE_FAILURE: any = 'ADDRESS_FETCH_ONE_FAILURE';

export const ADDRESS_SAVE: any = 'ADDRESS_SAVE';
export const ADDRESS_SAVE_QUEUE: any = 'ADDRESS_SAVE_QUEUE';
export const ADDRESS_SAVE_SUCCESS: any = 'ADDRESS_SAVE_SUCCESS';
export const ADDRESS_SAVE_FAILURE: any = 'ADDRESS_SAVE_FAILURE';

export const ADDRESS_SAVE_MANY: any = 'ADDRESS_SAVE_MANY';
export const ADDRESS_SAVE_MANY_QUEUE: any = 'ADDRESS_SAVE_MANY_QUEUE';
export const ADDRESS_SAVE_MANY_SUCCESS: any = 'ADDRESS_SAVE_MANY_SUCCESS';
export const ADDRESS_SAVE_MANY_FAILURE: any = 'ADDRESS_SAVE_MANY_FAILURE';

export const ADDRESS_REMOVE: any = 'ADDRESS_REMOVE';
export const ADDRESS_REMOVE_QUEUE: any = 'ADDRESS_REMOVE_QUEUE';
export const ADDRESS_REMOVE_SUCCESS: any = 'ADDRESS_REMOVE_SUCCESS';
export const ADDRESS_REMOVE_FAILURE: any = 'ADDRESS_REMOVE_FAILURE';

export const ADDRESS_RESTORE: any = 'ADDRESS_RESTORE';
export const ADDRESS_RESTORE_QUEUE: any = 'ADDRESS_RESTORE_QUEUE';
export const ADDRESS_RESTORE_SUCCESS: any = 'ADDRESS_RESTORE_SUCCESS';
export const ADDRESS_RESTORE_FAILURE: any = 'ADDRESS_RESTORE_FAILURE';

export const ADDRESS_RESTORE_MANY: any = 'ADDRESS_RESTORE_MANY';
export const ADDRESS_REMOVE_MANY: any = 'ADDRESS_REMOVE_MANY';

/* Fetch actions */
export const fetchAddressSuccess = (addresses: Address[], partial: boolean, lastFetch: number) => ({type: ADDRESS_FETCH_SUCCESS, addresses, partial, lastFetch});
export const fetchAddressFailure = (err: any) => {
		console.error('AddressAction: fetchAddressFailure', err);
		return {type: ADDRESS_FETCH_FAILURE, err};
};
export const fetchOneAddressQueue = (addressId: string) => ({type: ADDRESS_FETCH_ONE_QUEUE, addressId});
export const fetchOneAddressSuccess = (address: Address) => ({type: ADDRESS_FETCH_ONE_SUCCESS, address});
export const fetchOneAddressFailure = (id: string, err: any) => {
		console.error('AddressAction: fetchOneAddressFailure', err);
		return {type: ADDRESS_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveAddress = (address: Address) => {
    // console.debug('⮂ ADDRESS_SAVE action', address?.id);
    return {type: ADDRESS_SAVE, address};
}
export const saveAddressQueue = (address: Address, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ADDRESS_SAVE_QUEUE action', address?.id);
    return {type: ADDRESS_SAVE_QUEUE, address, onQueued};
}
export const saveAddressSuccess = (address: Address) => {
    // console.debug('⮂ ADDRESS_SAVE_SUCCESS action', address?.id);
    return {type: ADDRESS_SAVE_SUCCESS, address};
}
export const saveAddressFailure = (address: Address, status: number, message: string) => {
    console.warn(`⮂ ADDRESS_SAVE_FAILURE error saving address: HTTP ${status}: ${message}`, address?.id);
    return {type: ADDRESS_SAVE_FAILURE, address, status, message};
};

/* SaveMany actions */
export const saveManyAddresses = (addresses: Address[]) => {
    // console.debug('⮂ ADDRESS_SAVE_MANY action', addresses?.map(address => address?.id).join(','));
    return {type: ADDRESS_SAVE_MANY, addresses};
}
export const saveManyAddressesQueue = (addresses: Address[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ADDRESS_SAVE_MANY_QUEUE action', addresses?.map(address => address.id).join(','));
    return {type: ADDRESS_SAVE_MANY_QUEUE, addresses, onQueued};
}

export const saveManyAddressesSuccess = (addresses: Address[]) => {
    // console.debug('⮂ ADDRESS_SAVE_MANY_SUCCESS action', addresses?.map(address => address.id).join(','));
    return {type: ADDRESS_SAVE_MANY_SUCCESS, addresses};
}
export const saveManyAddressesFailure = (addresses: Address[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ADDRESSES_FAILURE Error saving addresses: HTTP ${status}: ${message}`, addresses?.map(address => address.id).join(','));
		return {type: ADDRESS_SAVE_MANY_FAILURE, addresses, status, message};
};

/* Remove actions */
export const removeAddress = (address: Address) => ({ type: ADDRESS_REMOVE, address });
export const removeAddressQueue = (address: Address) => ({ type: ADDRESS_REMOVE_QUEUE, address });
export const removeAddressSuccess = (address: Address) => ({ type: ADDRESS_REMOVE_SUCCESS, address });
export const removeAddressFailure = (address: Address, status: number, message: string) => {
	console.error(`Redux: removeAddressFailure Error removing address: HTTP ${status}: ${message}`);
	return ({ type: ADDRESS_REMOVE_FAILURE, address, status, message });
};

/* Restore actions */
export const restoreAddress = (address: Address) => ({ type: ADDRESS_RESTORE, address });
export const restoreAddressQueue = (address: Address) => ({ type: ADDRESS_RESTORE_QUEUE, address });
export const restoreAddressSuccess = (address: Address) => ({ type: ADDRESS_RESTORE_SUCCESS, address });
export const restoreAddressFailure = (address: Address, status: number, message: string) => {
	console.error(`Redux: restoreAddressFailure Error restoring address: HTTP ${status}: ${message}`);
	return ({ type: ADDRESS_RESTORE_FAILURE, address, status, message });
};

/* RestoreMany actions */
export const restoreManyAddresses = (addresses: Address[]) => ({ type: ADDRESS_RESTORE_MANY, addresses });

/* RemoveMany actions */
export const removeManyAddresses = (addresses: Address[]) => ({ type: ADDRESS_REMOVE_MANY, addresses });